import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { Paths } from "../../MainRouter";
import "./NotFound.scss";

const NotFoundPage = () => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const el = containerRef.current;
		if (el) {
			setTimeout(() => el.classList.add("visible"), 50);
		}
	}, []);

	return (
		<div ref={containerRef} className="not-found-page">
			{/* Decorative background circles */}
			<div className="nf-bg-circle nf-bg-circle--1" />
			<div className="nf-bg-circle nf-bg-circle--2" />
			<div className="nf-bg-circle nf-bg-circle--3" />

			<div className="nf-inner">
				{/* Giant 404 */}
				<div className="nf-code-wrap">
					<span className="nf-digit">4</span>
					<span className="nf-zero">
						<span className="nf-zero-inner">0</span>
					</span>
					<span className="nf-digit">4</span>
				</div>

				{/* Divider */}
				<div className="nf-divider">
					<span className="nf-divider-line" />
					<span className="nf-divider-diamond" />
					<span className="nf-divider-line" />
				</div>

				{/* Text block */}
				<div className="nf-text">
					<h1 className="nf-title">Page Not Found</h1>
					<p className="nf-subtitle">
						The page you&apos;re looking for doesn&apos;t exist or has been moved.
						<br />
						Let&apos;s get you back on track.
					</p>
				</div>

				{/* Actions */}
				<div className="nf-actions">
					<Link className="nf-btn nf-btn--primary" to={Paths.root}>
						Back to Home
					</Link>
					<Link className="nf-btn nf-btn--outline" to={Paths.contactUs}>
						Contact Us
					</Link>
				</div>

				{/* Footer hint */}
				<p className="nf-hint">
					Error&nbsp;<strong>404</strong>&nbsp;·&nbsp;Eurycele
				</p>
			</div>
		</div>
	);
};

export default NotFoundPage;
